import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const BodyWrapper = styled.div`
  position: absolute;
  top: 90px;
  right: 50px;
  z-index: 100;
  background: #004576;
  width: 275px;
  /* height: 400px; */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 20px 20px;

  @media (max-width: 480px) {
    top: 74px;
    right: 11px;
  }

  .header {
    display: flex;
    width: 100%;

    .textContainer {
      width: 80%;
      .headerText {
        font-weight: 700;
        font-size: 16px;
        color: #ffffff;
      }

      .subHeaderText {
        font-weight: 400;
        font-size: 12px;
        color: #6ac7dd;
        margin-top: 10px;
      }
    }

    .crossButtonContainer {
      width: 20%;
      justify-content: end;
      display: flex;
      color: white;

      span {
        cursor: pointer;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }

  .infoSection {
    margin-top: 20px;

    .sectionHeaderText {
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
    }

    .infoText {
      margin-top: 10px;
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      padding: 15px 0px;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconContainer {
        display: flex;
        justify-content: center;
        color: #004576;
        font-size: 20px;
      }

      .text {
        margin-top: 15px;
        font-weight: 400;
        font-size: 16px;
        color: #008ef2;
        cursor: pointer;
        text-decoration: underline;

        a {
          color: #008ef2;
        }
      }
    }
  }
`;

const GarwoodHelpPopup = ({ setIsHelpPopupVisible }) => {
  return (
    <BodyWrapper>
      <div className="header">
        <div className="textContainer">
          <div className="headerText">Application Support</div>
          <div className="subHeaderText">Powered by Gar Wood Securities</div>
        </div>
        <div className="crossButtonContainer">
          <span onClick={() => setIsHelpPopupVisible(false)}>X</span>
        </div>
      </div>
      <div className="infoSection">
        <div className="sectionHeaderText">Phone Support</div>
        <div className="infoText">
          <div>
            <div className="iconContainer">
              <FontAwesomeIcon icon={faPhone} />
            </div>
            <div className="text">
              <a href="tel:+18777362510" style={{ textDecoration: "none" }}>
                +1 (877) 736-2510
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="infoSection">
        <div className="sectionHeaderText">Email Support</div>
        <div className="infoText">
          <div>
            <div className="iconContainer">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>
            <div
              className="text"
              onClick={() =>
                window.open("mailto:missioncontrol@tactivewealth.com")
              }
            >
              missioncontrol@tactivewealth.com
            </div>
          </div>
        </div>
      </div>
    </BodyWrapper>
  );
};

export default GarwoodHelpPopup;
